.l{width:100%;}